"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createDraft: function() {
        return createDraft;
    },
    deleteDraft: function() {
        return deleteDraft;
    },
    duplicateDraft: function() {
        return duplicateDraft;
    },
    resetDrafts: function() {
        return resetDrafts;
    },
    updateDraft: function() {
        return updateDraft;
    }
});
const _types = /*#__PURE__*/ _interop_require_wildcard(require("./types/index.js"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function createDraft(payload) {
    return {
        type: _types.ADD_DRAFT,
        payload
    };
}
function duplicateDraft(payload) {
    return {
        type: _types.DUPLICATE_DRAFT,
        payload
    };
}
function updateDraft(payload) {
    return {
        type: _types.UPDATE_DRAFT,
        payload
    };
}
function deleteDraft(id) {
    return {
        type: _types.DELETE_DRAFT,
        payload: id
    };
}
function resetDrafts() {
    return {
        type: _types.RESET_DRAFTS
    };
}
